import { Entity } from '@app/shared/models/models.interface';
import { AbstractSelectionModel } from './abstractSelectionModel';

/**
 * A selection model Entity oriented.
 *
 * This class
 */
export class EntitySelectionModel<T extends Entity> extends AbstractSelectionModel<T> {
  protected equals(a: T, b: T): boolean {
    return a.id === b.id;
  }
}
